"use strict";
// export enum IInsightStatus {
//   Requested = 'requested',
//   InProgress = 'in_progress',
//   Done = 'done',
//   Failed = 'failed',
// }
Object.defineProperty(exports, "__esModule", { value: true });
